module.exports = __webpack_public_path__ + "img/illustrations/drag-and-drop-b2644e5022e7fee8520b62c29d9ba393.svg";